import React, { useState } from 'react';
import TimePicker from './TimePicker';
import { getMomentDate } from '../../../Utils/dates.util';
import moment, { Moment } from 'moment';

interface Props {
	name: string;
	isRequired?: boolean;
	placeholder?: string;
	value?: string;
	onChange?: (value: string) => void;
}

const TimePickerPHP: React.FC<Props> = ({ value, onChange, name }) => {
	const [val, setVal] = useState(value);
	const handleOnChange = (value: any) => {
		setVal(value ? value.format('HH:mm') : undefined);
		onChange?.(value ? value.format('HH:mm') : undefined);
	};

	return (
		<>
			<TimePicker
				value={val ? moment().format('YYYY-MM-DD') + ' ' + val : undefined}
				onChange={handleOnChange}
				style={{ marginBottom: 0 }}
			/>
			<input
				style={{ display: 'none' }}
				name={name}
				value={val ?? ''}
				onChange={e => setVal(e.target.value || undefined)}
			/>
		</>
	);
};

export default TimePickerPHP;
